import React from "react"
import Navbar from "react-bootstrap/Navbar"
import { Nav } from "react-bootstrap"
import { Link } from "gatsby"

class TopNavBar extends React.Component {
  constructor(props) {
    super(props)
  }

  isActive({ isCurrent }) {
    return isCurrent ? { className: "active" } : null
  }

  render() {
    return (
      <Navbar collapseOnSelect expand="lg" fixed="top">
        <Navbar.Brand>
          <img
            alt="Logo"
            src={"/images/logo.webp"}
            width="30"
            height="30"
            className="d-inline-block align-top"
          />{" "}
          Sameeha Rahman
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsiveNavbar" />
        <Navbar.Collapse id="responsiveNavbar" className="justify-content-end">
          <Link to="/" getProps={this.isActive} exact>
            <Nav.Item>Home</Nav.Item>
          </Link>
          <Link to="/posts" getProps={this.isActive}>
            <Nav.Item>Blog Posts</Nav.Item>
          </Link>
        </Navbar.Collapse>
      </Navbar>
    )
  }
}

export default TopNavBar
